import { render } from "./NotificationWidget.vue?vue&type=template&id=4268af5c&scoped=true"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"

import "./NotificationWidget.vue?vue&type=style&index=0&id=4268af5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4268af5c"]])

export default __exports__